/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_SourcesInputs */

const en_pc_rv_sources = /** @type {(inputs: Pc_Rv_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources: the PhotoCraft README and docs, getartcraft.com, and hands-on coverage by OMG! Ubuntu, October 2026.`)
};

const zh_pc_rv_sources = /** @type {(inputs: Pc_Rv_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资料来源：PhotoCraft README 与文档、getartcraft.com，以及 OMG! Ubuntu 2026 年 10 月的上手评测。`)
};

/**
* | output |
* | --- |
* | "Sources: the PhotoCraft README and docs, getartcraft.com, and hands-on coverage by OMG! Ubuntu, October 2026." |
*
* @param {Pc_Rv_SourcesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_sources = /** @type {((inputs?: Pc_Rv_SourcesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_SourcesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_sources(inputs)
	return zh_pc_rv_sources(inputs)
});
export { pc_rv_sources as "pc.rv.sources" }